// ── Nav scroll effect ──────────────────────────────────────────────────────
const siteHeader = document.querySelector('.site-header');
if (siteHeader) {
  const updateHeaderHeight = () => document.documentElement.style.setProperty('--site-header-height', `${siteHeader.offsetHeight}px`);
  updateHeaderHeight();
  if (window.ResizeObserver) new ResizeObserver(updateHeaderHeight).observe(siteHeader);
  else window.addEventListener('resize', updateHeaderHeight);
}
window.addEventListener('scroll', () => {
  document.querySelector('nav')?.classList.toggle('scrolled', window.scrollY > 60);
});

// ── Mobile Navigation ──────────────────────────────────────────────────────
function toggleMobileNav() {
  const nav = document.getElementById('mobile-nav');
  const overlay = document.getElementById('mobile-nav-overlay');
  const burger = document.getElementById('hamburger');
  if (!nav) return;
  const isOpen = nav.classList.contains('open');
  nav.classList.toggle('open', !isOpen);
  overlay.classList.toggle('open', !isOpen);
  burger.classList.toggle('open', !isOpen);
  burger.setAttribute('aria-expanded', String(!isOpen));
  document.body.style.overflow = isOpen ? '' : 'hidden';
}
function closeNav() {
  document.getElementById('mobile-nav')?.classList.remove('open');
  document.getElementById('mobile-nav-overlay')?.classList.remove('open');
  document.getElementById('hamburger')?.classList.remove('open');
  document.body.style.overflow = '';
}

// ── Cart Badge ─────────────────────────────────────────────────────────────
function updateCartBadge(count) {
  const badge = document.getElementById('cart-count-badge');
  if (!badge) return;
  if (count > 0) {
    badge.textContent = count;
    badge.style.display = 'inline';
  } else {
    badge.style.display = 'none';
  }
}

// ── Cart Drawer ─────────────────────────────────────────────────────────────
const FREE_SHIPPING_THRESHOLD = 150000; // 1500 EGP in cents — matches settings

function openCartDrawer() {
  closeNav();
  refreshCartDrawer().then(() => {
    document.getElementById('cart-drawer')?.classList.add('open');
    document.getElementById('cart-drawer-overlay')?.classList.add('open');
    document.body.style.overflow = 'hidden';
  });
}

function closeCartDrawer() {
  document.getElementById('cart-drawer')?.classList.remove('open');
  document.getElementById('cart-drawer-overlay')?.classList.remove('open');
  document.body.style.overflow = '';
}

// Close on Escape key
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    closeCartDrawer();
    closeNav();
  }
});

function refreshCartDrawer() {
  return fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const body   = document.getElementById('cart-drawer-body');
      const footer = document.getElementById('cart-drawer-footer');
      const countEl  = document.getElementById('drawer-item-count');
      const subtotalEl = document.getElementById('drawer-subtotal');
      const shippingBarEl = document.getElementById('drawer-shipping-bar');

      // Update nav badge
      updateCartBadge(cart.item_count);

      // Item count label
      if (countEl) {
        countEl.textContent = cart.item_count + ' ' + (cart.item_count === 1 ? 'ITEM' : 'ITEMS');
      }

      if (cart.item_count === 0) {
        body.innerHTML = `
          <div class="cart-drawer-empty">
            <div class="cart-drawer-empty-icon">🛒</div>
            <div class="cart-drawer-empty-title">YOUR BAG IS EMPTY</div>
            <p class="cart-drawer-empty-sub">Add something beautiful to begin.</p>
            <a href="/collections" class="cart-drawer-empty-cta" style="margin-top:20px;">SHOP NOW →</a>
          </div>`;
        if (footer) footer.style.display = 'none';
        return;
      }

      // Format money
      const fmt = (cents) => new Intl.NumberFormat('en-US', {
        style: 'currency', currency: cart.currency
      }).format(cents / 100);

      // Subtotal
      if (subtotalEl) subtotalEl.textContent = fmt(cart.total_price);

      // Free shipping progress bar
      if (shippingBarEl) {
        const threshold = FREE_SHIPPING_THRESHOLD;
        if (cart.total_price < threshold) {
          const remaining = threshold - cart.total_price;
          const pct = Math.min(100, (cart.total_price / threshold) * 100);
          shippingBarEl.innerHTML = `
            <div class="drawer-shipping-bar">
              <p>Add <strong>${fmt(remaining)}</strong> for free shipping</p>
              <div class="drawer-shipping-track">
                <div class="drawer-shipping-fill" style="width:${pct}%"></div>
              </div>
            </div>`;
        } else {
          shippingBarEl.innerHTML = `
            <div class="drawer-shipping-bar">
              <p><strong>✓ You've unlocked free shipping!</strong></p>
            </div>`;
        }
      }

      // Render items
      body.innerHTML = cart.items.map(item => `
        <div class="cart-drawer-item">
          <div class="cart-drawer-img">
            ${item.image ? `<img src="${item.image}" alt="${item.product_title}" loading="lazy">` : ''}
          </div>
          <div class="cart-drawer-info">
            <div>
              <div class="cart-drawer-item-type">${(item.product_type || 'AESTRA').toUpperCase()}</div>
              <div class="cart-drawer-item-name">${item.product_title.toUpperCase()}</div>
              ${item.variant_title && item.variant_title !== 'Default Title'
                ? `<div class="cart-drawer-item-variant">${item.variant_title.toUpperCase()}</div>`
                : ''}
            </div>
            <div class="cart-drawer-item-bottom">
              <div class="cart-drawer-qty">
                <button onclick="drawerUpdateQty('${item.key}', ${item.quantity - 1})" aria-label="Decrease quantity">−</button>
                <span>${item.quantity}</span>
                <button onclick="drawerUpdateQty('${item.key}', ${item.quantity + 1})" aria-label="Increase quantity">+</button>
              </div>
              <div style="display:flex;align-items:center;gap:10px;">
                <span class="cart-drawer-item-price">${fmt(item.final_line_price)}</span>
                <button class="cart-drawer-remove" onclick="drawerRemoveItem('${item.key}', this)" aria-label="Remove item">✕</button>
              </div>
            </div>
          </div>
        </div>
      `).join('');

      if (footer) footer.style.display = 'block';
    });
}

function drawerUpdateQty(key, qty) {
  if (qty < 0) return;
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  }).then(() => refreshCartDrawer());
}

function drawerRemoveItem(key, btn) {
  if (btn) {
    const itemEl = btn.closest('.cart-drawer-item');
    if (itemEl) {
      itemEl.style.transition = 'opacity 0.25s ease, transform 0.25s ease, padding 0.3s ease, margin 0.3s ease, max-height 0.3s ease';
      itemEl.style.maxHeight = itemEl.scrollHeight + 'px';
      // Force a reflow to ensure the transition runs
      itemEl.offsetHeight; 
      itemEl.style.opacity = '0';
      itemEl.style.transform = 'translateX(20px)';
      itemEl.style.maxHeight = '0px';
      itemEl.style.marginBottom = '0px';
      itemEl.style.paddingTop = '0px';
      itemEl.style.paddingBottom = '0px';
      itemEl.style.overflow = 'hidden';
      itemEl.style.borderBottom = 'none';
      
      // Temporarily change the X to a spinner or just hide it
      btn.style.opacity = '0';
    }
  }

  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  }).then(() => refreshCartDrawer());
}

// ── Add-to-cart helper (called by product/collection pages) ────────────────
// Fires after any page's addToCart or quickAdd completes
function onAddedToCart() {
  openCartDrawer();
}

// ── Quick Add (used by collection, search, cart upsell) ────────────────────
function quickAdd(id, btn) {
  if (btn) {
    if (btn.disabled) return;
    btn.disabled = true;
    btn.textContent = '…';
  }
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id, quantity: 1 })
  }).then(response => {
    if (!response.ok) throw new Error('Cart add failed');
    if (btn) {
      const productCard = btn.closest('.product-card') || btn.closest('.drawer-upsell-item');
      const sourceImg = productCard && productCard.querySelector('img');
      if (sourceImg && typeof flyToCart === 'function') flyToCart(sourceImg);
      btn.textContent = '✓';
    }
    if (typeof onAddedToCart === 'function') onAddedToCart();
    if (btn) {
      setTimeout(() => {
        btn.textContent = '+';
        btn.disabled = false;
      }, 1500);
    } else {
      // No button reference (e.g. cart upsell) — reload page
      location.reload();
    }
  }).catch(() => {
    if (btn) {
      btn.textContent = '!';
      btn.disabled = false;
      btn.title = 'Could not add to cart. Try again.';
    }
  });
}

// ── Color swatches ─────────────────────────────────────────────────────────
document.querySelectorAll('.product-colors').forEach(row => {
  row.querySelectorAll('.color-dot').forEach(dot => {
    dot.addEventListener('click', () => {
      row.querySelectorAll('.color-dot').forEach(d => d.classList.remove('active'));
      dot.classList.add('active');
    });
  });
});

// ── Quick View Modal ───────────────────────────────────────────────────────
function openQuickView(e, handle) {
  e.preventDefault();
  e.stopPropagation(); // Prevent navigating to product page
  
  const overlay = document.getElementById('qv-overlay');
  const modal = document.getElementById('qv-modal');
  const content = document.getElementById('qv-content');
  
  if (!overlay || !modal || !content) return;

  // Show modal with loading state
  content.innerHTML = '<div class="qv-loading">LOADING...</div>';
  overlay.classList.add('active');
  modal.classList.add('active');
  document.body.style.overflow = 'hidden';

  // Fetch the Quick View section HTML for this product
  fetch(`/products/${handle}?section_id=quick-view`)
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const sectionContent = doc.querySelector('.shopify-section') || doc.body;
      content.innerHTML = sectionContent.innerHTML;
      
      initQuickViewLogic();
    })
    .catch(err => {
      content.innerHTML = '<div class="qv-loading">Failed to load product.</div>';
    });
}

function initQuickViewLogic() {
  const container = document.querySelector('.qv-inner-layout');
  if (!container) return;
  
  const jsonEl = document.getElementById('qv-variants-json');
  if (!jsonEl) return;
  const variants = JSON.parse(jsonEl.textContent);
  
  let selectedOptions = [];
  
  // Initialize selectedOptions array based on currently active buttons
  container.querySelectorAll('.qv-option-btn.active').forEach(btn => {
    const index = parseInt(btn.getAttribute('data-index'));
    selectedOptions[index] = btn.getAttribute('data-value');
  });

  function refreshQV() {
    const matched = variants.find(v => v.options.every((o, i) => o === selectedOptions[i]));
    const addBtn = document.getElementById('qv-add-cart');
    
    if (matched && addBtn) {
      addBtn.setAttribute('data-id', matched.id);
      if (!matched.available) {
         addBtn.textContent = 'SOLD OUT';
         addBtn.disabled = true;
         addBtn.style.opacity = '0.5';
      } else {
         addBtn.textContent = 'ADD TO CART';
         addBtn.disabled = false;
         addBtn.style.opacity = '1';
      }
      
      // Update sold-out states on all option buttons
      container.querySelectorAll('.qv-option-btn').forEach(btn => {
        const index = parseInt(btn.getAttribute('data-index'));
        const val = btn.getAttribute('data-value');
        
        const testOptions = [...selectedOptions];
        testOptions[index] = val;
        
        const hasAvail = variants.some(v => v.available && v.options.every((o, i) => {
          if (i === index) return o === val;
          return o === testOptions[i];
        }));
        
        if (hasAvail) {
          btn.classList.remove('sold-out');
        } else {
          btn.classList.add('sold-out');
        }
      });
    }
  }

  // Bind click events using event delegation
  container.addEventListener('click', function(e) {
    const btn = e.target.closest('.qv-option-btn');
    if (!btn) return;
    if (btn.classList.contains('sold-out')) return;
    
    const index = parseInt(btn.getAttribute('data-index'));
    const group = btn.closest('.qv-option-group');
    if (group) {
      group.querySelectorAll('.qv-option-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    }
    
    selectedOptions[index] = btn.getAttribute('data-value');
    refreshQV();
  });

  // Initial calculation
  refreshQV();
}

window.qvChangeQty = function(dir) {
  const display = document.getElementById('qv-qty-display');
  if (!display) return;
  let q = parseInt(display.textContent) + dir;
  if (q < 1) q = 1;
  display.textContent = q;
};

window.qvAddToCart = function(btn) {
  const id = btn.getAttribute('data-id');
  if (!id) return;
  
  const display = document.getElementById('qv-qty-display');
  const qty = display ? parseInt(display.textContent) : 1;
  
  btn.disabled = true;
  btn.textContent = 'ADDING...';
  
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: id, quantity: qty })
  }).then(response => {
    if (!response.ok) throw new Error('Cart add failed');
    const sourceImg = document.querySelector('.qv-left img');
    if (sourceImg && typeof flyToCart === 'function') flyToCart(sourceImg);
    btn.textContent = '✓ ADDED';
    if (typeof onAddedToCart === 'function') onAddedToCart();
    else if (typeof openCartDrawer === 'function') openCartDrawer();
    setTimeout(() => closeQuickView(), 500);
  }).catch(() => {
    btn.textContent = 'COULD NOT ADD — TRY AGAIN';
    btn.disabled = false;
  });
};

function closeQuickView() {
  const overlay = document.getElementById('qv-overlay');
  const modal = document.getElementById('qv-modal');
  if (overlay) overlay.classList.remove('active');
  if (modal) modal.classList.remove('active');
  document.body.style.overflow = '';
}

// ── Fly To Cart Animation ──────────────────────────────────────────────────
window.flyToCart = function(sourceImg) {
  const cartIcon = document.getElementById('cart-icon-btn');
  if (!sourceImg || !cartIcon) return;

  const srcRect = sourceImg.getBoundingClientRect();
  const cartRect = cartIcon.getBoundingClientRect();

  const clone = sourceImg.cloneNode(true);
  clone.classList.add('fly-to-cart-clone');
  
  clone.style.top = srcRect.top + 'px';
  clone.style.left = srcRect.left + 'px';
  clone.style.width = srcRect.width + 'px';
  clone.style.height = srcRect.height + 'px';
  clone.style.margin = '0';
  clone.style.borderRadius = '4px';
  
  document.body.appendChild(clone);

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      // Calculate delta from center to center
      const startCenterX = srcRect.left + srcRect.width / 2;
      const startCenterY = srcRect.top + srcRect.height / 2;
      const targetCenterX = cartRect.left + cartRect.width / 2;
      const targetCenterY = cartRect.top + cartRect.height / 2;
      
      const deltaX = targetCenterX - startCenterX;
      const deltaY = targetCenterY - startCenterY;

      // Ensure it shrinks exactly to the size of the cart icon (approx 24px)
      const scaleTo = Math.min(24 / srcRect.width, 24 / srcRect.height);

      // Add a slight rotation for a playful, premium effect
      clone.style.transform = `translate(${deltaX}px, ${deltaY}px) scale(${scaleTo}) rotate(15deg)`;
      clone.style.opacity = '0.1';
      clone.style.borderRadius = '50%'; // Morph into a circle
    });
  });

  setTimeout(() => {
    if (document.body.contains(clone)) {
      document.body.removeChild(clone);
    }
  }, 650);
};
